'use strict';

/* eslint no-unused-vars: ["error", { "varsIgnorePattern": "^proThumbCarousel|prodCarousel" }]*/

const Swiper = require('swiper/swiper-bundle.min.js');

module.exports = function () {
    const $hbSwiper = document.querySelector('#hbSwiper');
    const $hbThumbSwiper = document.querySelector('#hbSwiperThumb');

    if ($hbThumbSwiper !== null) {
        const proThumbCarousel = new Swiper($hbThumbSwiper, {
            direction: 'horizontal',
            loop: false,
            spaceBetween: 20,
            slidesPerView: 'auto',
            freeMode: false,
            pagination: {
                el: '.swiper-pagination.thumb',
                type: 'bullets',
                enabled: false,
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next.thumb',
                prevEl: '.swiper-button-prev.thumb'
            },
            scrollbar: {
                el: '.swiper-scrollbar.thumb',
                draggable: true,
                hide: false,
                enabled: false
            }
        });
    }

    if ($hbSwiper !== null) {
        const prodCarousel = new Swiper($hbSwiper, {
            direction: 'horizontal',
            thumbs: {
                swiper: $hbThumbSwiper
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                enabled: true,
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-nav-next-pdpImg',
                prevEl: '.swiper-nav-prev-pdpImg',
                enabled: false
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                hide: false,
                enabled: false
            },
            breakpoints: {
                991: {
                    allowTouchMove: false,
                    pagination: {
                        enabled: false
                    },
                    scrollbar: {
                        enabled: false
                    }
                }
            }
        });
    }
};
